import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";

/**
 * Catch-all route. Before this existed, any unmatched URL rendered the navbar
 * and footer with nothing in between -- a blank page rather than an error.
 * Google treats those as soft 404s, and several dead URLs were sitting in the
 * sitemap because of it.
 */
export default function NotFoundPage() {
  return (
    <>
      <Seo
        title="Page Not Found | BIBA Electronics"
        description="This page does not exist. Browse BIBA Electronics' displays, embedded design and manufacturing services, or get in touch for a quote."
        noindex
      />
      <main
        style={{
          maxWidth: "640px",
          margin: "0 auto",
          padding: "96px 24px 120px",
          textAlign: "center",
        }}
      >
        <p
          style={{
            fontSize: "0.75rem",
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            color: "#64748b",
            margin: "0 0 12px",
          }}
        >
          Error 404
        </p>

        <h1 style={{ fontSize: "2rem", lineHeight: 1.2, margin: "0 0 16px", color: "#0f172a" }}>
          We couldn&rsquo;t find that page
        </h1>

        <p style={{ color: "#475569", margin: "0 0 32px", lineHeight: 1.6 }}>
          The link may be out of date, or the page may have moved. Here is where most
          people are heading:
        </p>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "12px",
            justifyContent: "center",
          }}
        >
          {[
            ["/", "Home"],
            ["/ems", "Manufacturing Services"],
            ["/embedded", "Embedded Design"],
            ["/tft-display", "Displays"],
            ["/contact", "Contact Us"],
          ].map(([to, label]) => (
            <Link
              key={to}
              to={to}
              style={{
                padding: "10px 18px",
                border: "1px solid #cbd5e1",
                borderRadius: "8px",
                color: "#0f172a",
                textDecoration: "none",
                fontSize: "0.95rem",
              }}
            >
              {label}
            </Link>
          ))}
        </div>
      </main>
    </>
  );
}
